import { Container, Image } from 'react-bootstrap';
import Slider from 'react-slick';
import DigitalQLogo from 'assets/img/landing/customers/digitalQ.svg';
import IOPEXLogo from 'assets/img/landing/customers/iopex.svg';
import ZitrinoLogo from 'assets/img/landing/customers/zitrino.svg';
import NanMuthalvan from 'assets/img/landing/customers/nanMuthalvan.svg';
import InfiniteLogo from 'assets/img/landing/customers/infinite.svg';
import { useEffect, useState } from 'react';

function OurCustomers() {
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  const settings = {
    infinite: true,
    slidesToShow: isMobileScreen ? 2 : 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    cssEase: 'linear',
    nextArrow: <></>,
    prevArrow: <></>
  };

  useEffect(() => {
    const windowSize = window.innerWidth;
    if (windowSize <= 650) {
      setIsMobileScreen(true);
    } else {
      setIsMobileScreen(false);
    }
  }, []);

  return (
    <Container fluid className="px-lg-14 pt-5 pb-15 bg-gray-200">
      <p className="text-center pb-8 fs-7">Trusted Customers</p>

      <div className="slider-container">
        <Slider {...settings}>
          <Image src={DigitalQLogo} alt="CustomerLogo" height={40} />
          <Image src={IOPEXLogo} alt="CustomerLogo" height={40} />
          <Image src={ZitrinoLogo} alt="CustomerLogo" height={40} />
          <Image src={InfiniteLogo} alt="CustomerLogo" height={40} />
          <Image src={NanMuthalvan} alt="CustomerLogo" height={40} />
        </Slider>
      </div>
    </Container>
  );
}

export default OurCustomers;
